import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-60">
      <div className="container mx-auto px-4" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-62">
          <div className="col-span-1" data-id="element-63">
            <h2 className="text-2xl font-bold mb-4" data-id="element-64">SuperNeil.com</h2>
            <p className="text-gray-400 mb-6 max-w-md" data-id="element-65">
              Helping foreign entrepreneurs successfully navigate the U.S. tax
              system with fast, reliable ITIN application services through our
              partner TheITIN.com.
            </p>
          </div>
          <div data-id="element-66">
            <h3 className="text-lg font-semibold mb-4" data-id="element-67">Quick Links</h3>
            <ul className="space-y-2" data-id="element-68">
              <li data-id="element-69">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-70">
                  Home
                </a>
              </li>
              <li data-id="element-71">
                <a href="#benefits" className="text-gray-400 hover:text-white transition-colors" data-id="element-72">
                  Benefits
                </a>
              </li>
              <li data-id="element-73">
                <a href="#process" className="text-gray-400 hover:text-white transition-colors" data-id="element-74">
                  Process
                </a>
              </li>
              <li data-id="element-75">
                <a href="#pricing" className="text-gray-400 hover:text-white transition-colors" data-id="element-76">
                  Pricing
                </a>
              </li>
              <li data-id="element-77">
                <a href="#faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-78">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400 text-sm" data-id="element-79">
          <p className="mb-2" data-id="element-80">
            © {new Date().getFullYear()} SuperNeil.com. All rights reserved.
          </p>
          <div className="flex justify-center space-x-6" data-id="element-81">
            <a href="#" className="hover:text-white transition-colors" data-id="element-82">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-83">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-84">
              Disclaimer
            </a>
          </div>
          <p className="mt-4 max-w-2xl mx-auto" data-id="element-85">
            This website is operated by SuperNeil.com, an affiliate of
            TheITIN.com. When you purchase through links on this site, we may
            earn an affiliate commission.
          </p>
          <p className="mt-4 max-w-2xl mx-auto" data-id="element-86">
            DISCLAIMER: We provide information only and refer users to
            TheITIN.com. SuperNeil.com is not a tax preparation service or
            IRS-certified acceptance agent.
          </p>
        </div>
      </div>
    </footer>;
}